<template>
  <v-container v-if="selectedScenario._id && selectedWorkpackage" fluid>
    <v-row class="main-layout w-100 flex-column ma-0">
      <v-col cols="12">
        <Toolbar
          back-nav-route="HomePage"
          enable-notes
          enable-scenario-selection
          :toolbar-tabs="toolbarTabs"
          :workpackage="selectedWorkpackage"
          :hide-slider="false"
        />
        <!-- ensure that the component is re-rendered when navigating between
         different scenarios, as the route is the same but the params change -->
        <router-view :key="$route.params.scenarioId" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { useAssortmentCanvasStore } from '@/stores/assortment-canvas';
import { useScenariosStore } from '@/stores/scenarios';
import { useWorkpackagesStore } from '@/stores/workpackages';
import toolbarTabs from '@/utils/tabs/toolbar-tabs-enum';
import { mapActions, mapState } from 'pinia';

export default {
  async beforeRouteUpdate(to, from, next) {
    if (this.requiresStateReload(to.params.canvasId, to.params.scenarioId))
      await this.loadState({
        scenarioId: to.params.scenarioId,
        canvasId: to.params.canvasId,
      });
    return next();
  },

  data() {
    return { toolbarTabs };
  },

  computed: {
    ...mapState(useWorkpackagesStore, ['selectedWorkpackage']),
    ...mapState(useScenariosStore, ['selectedScenario']),
    ...mapState(useAssortmentCanvasStore, ['selectedCanvas', 'canvases']),

    scenarioId() {
      return this.$route.params.scenarioId;
    },
  },

  async created() {
    await this.loadState({ scenarioId: this.scenarioId, canvasId: this.$route.params.canvasId });
    this.handleSelectingCanvas();
  },

  methods: {
    ...mapActions(useWorkpackagesStore, ['loadState']),
    ...mapActions(useAssortmentCanvasStore, [
      'fetchCanvases',
      'fetchCanvasesForSelectedWorkpackage',
    ]),

    requiresStateReload(canvasId, scenarioId) {
      // If changing routes and the canvasId in route is different to selectedCanvas we need to load state
      if (canvasId !== this.selectedCanvas._id) return true;
      // If we are changing routes inside the same scenario we just continue
      if (scenarioId === this.selectedScenario._id) return false;
      return true;
    },

    async handleSelectingCanvas() {
      // First load all available live canvases for the scenario
      await this.fetchCanvases({ params: { where: { live: true } } });
      // If in the canvas page - load all canvases for the workpackage
      // So we can disable the scenario selector in toolbar if no canvas is available for a scenario
      if (this.$route.name === toolbarTabs.ASSORTMENTS_PANEL_TAB) {
        await this.fetchCanvasesForSelectedWorkpackage();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-layout {
  height: 100%;
}
</style>
